import { render } from "./settings_general.vue?vue&type=template&id=57c675bf"
import script from "./settings_general.vue?vue&type=script&lang=js"
export * from "./settings_general.vue?vue&type=script&lang=js"
script.render = render

export default script